module.exports = __webpack_public_path__ + "media/images/badge/esperto_secondary-598b705a781d2138c3d8fd9fbb02bb73.png";